import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3r3tx0p8lp: FaireBrandEntity = {
  token: "b_3r3tx0p8lp",
  type: "brand",
  name: "Bamboo Trading Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/d6f65e9f3151de079431d00debd89783c59ef4a739ff6514a7d8609359b81b50.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ef50aa62838b64ff4cd2b627d64bf85b23574c3d8b4b521a688cff5f1c1bbd3d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d6f65e9f3151de079431d00debd89783c59ef4a739ff6514a7d8609359b81b50.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ef50aa62838b64ff4cd2b627d64bf85b23574c3d8b4b521a688cff5f1c1bbd3d.jpeg",
  location: "Longwood, FL, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 372,
  isInsider: true,
  description:
    "Bamboo Trading Company is a globally conscious leader in the fashion accessories manufacturing and distribution business. Our mission is to be a fun and prosperous company that creates and distributes quality products. We are committed to an environment which fosters personal growth and values all partnerships.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:49.068Z",
    importedBy: "entity-db-cli",
  },
};
